module.exports = __webpack_public_path__ + "static/media/rank-05-proficient.58398264.svg";